// extracted by mini-css-extract-plugin
export default {"shorten":"shorten_shorten__tWnbv"};